import { render } from "./AcceptFormBox.vue?vue&type=template&id=eff4e648"
import script from "./AcceptFormBox.vue?vue&type=script&lang=js"
export * from "./AcceptFormBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__